import { useState } from "react";

function About() {
  const [isExpanded, setIsExpanded] = useState(false);

return (
  <section
    id="about2"
    className="bg-gray-900 py-20 px-4 md:px-20 flex flex-col items-center"
    style={{ perspective: "1200px" }}
  >

{/* 📄 Paper Box */}
    <div
      className="bg-[#fdfaf3] text-gray-800 w-[90%] mx-auto p-8 md:p-12 shadow-2xl relative overflow-hidden transition-transform duration-200 ease-out"
      style={{
        clipPath:
          "polygon(0% 2%, 5% 0%, 10% 2%, 15% 0%, 20% 2%, 25% 0%, 30% 2%, 35% 0%, 40% 2%, 45% 0%, 50% 2%, 55% 0%, 60% 2%, 65% 0%, 70% 2%, 75% 0%, 80% 2%, 85% 0%, 90% 2%, 95% 0%, 100% 2%, 100% 98%, 95% 100%, 90% 98%, 85% 100%, 80% 98%, 75% 100%, 70% 98%, 65% 100%, 60% 98%, 55% 100%, 50% 98%, 45% 100%, 40% 98%, 35% 100%, 30% 98%, 25% 100%, 20% 98%, 15% 100%, 10% 98%, 5% 100%, 0% 98%)",
        transformStyle: "preserve-3d",
      }}
    >

      {/* Paper Lines */}
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="h-full w-full bg-[linear-gradient(to_bottom,transparent_94%,#9ca3af_94%)] bg-[length:100%_28px]" />
      </div>

      {/* Title */}
      <h2 className="text-3xl md:text-4xl font-[Playfair_Display] font-bold mb-6 text-gray-900 relative z-10">
        Why Choose VibeWeb Media as Digital Marketing Agency?
      </h2>

      {/* Content */}
      <div className="space-y-6 text-[18px] leading-[28px] font-[Playfair_Display] relative z-10">

        {/* Drop Cap Paragraph */}
        <p className="relative">
          <span className="float-left text-[70px] leading-[56px] font-bold mr-3 text-red-500">
            W
          </span>
          <span>
            e focus on delivering strategies that actually drive results, not just impressions. By combining data-driven insights with creative execution, we help your brand reach the right audience and turn engagement into real growth.
          </span>
        </p>

        {/* Expandable Section */}
        <div
          className={`transition-all duration-500 ease-in-out overflow-hidden ${
            isExpanded ? "max-h-[560px] opacity-100 mt-[28px]" : "max-h-0 opacity-0"
          }`}
        >
          <p className="leading-[28px] text-[18px]">
            Our team blends marketing expertise with modern digital tools to build campaigns that are both effective and scalable. From SEO to social media and paid ads, every solution is tailored to your business goals.
          </p>

          <p className="leading-[28px] text-[18px] mt-[28px]">
            At VibeWeb Media, we believe in transparency and long-term partnerships. We keep you informed at every step, continuously optimize performance, and ensure your brand stays ahead in a competitive digital landscape.
          </p>
        </div>

        {/* Button */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="relative overflow-hidden font-[Caveat] group inline-block align-baseline leading-[35px] h-[35px]"
        >
          <span className="relative z-10 italic text-red-500 transition-colors duration-300 group-hover:text-red-800">
            {isExpanded ? "Show Less ↑" : "Read More ↓"}
          </span>

          <span className="absolute left-0 top-0 h-full w-0 bg-yellow-400 opacity-50 transition-all duration-300 ease-out group-hover:w-full"></span>
        </button>
      </div>
    </div>
  </section>
);
}

export default About;